module.exports = __webpack_public_path__ + "img/Webデータベースシステム入門6_4_2.ba83fe51.png";